/**
 * 司机档案相关请求
 */
import request from "@/utils/request";
import { BooleanResponse, CompanyConfigRequest, DriverCoreSkills, DriverRiskProfile, DriverRiskProfileCompanyConf, DriverWorkExperience, FaceInfo, iAllDriverRegistrationInfoRequest, iAllDriverRegistrationInfoResponse, iBindFaceNewResponse, iDriverRequest, iDriverResponse, iFaceInfoRequest, iFaceInfoResponse, iFaceResponse, iGetDriverArchiveListRequest, iGetDriverArchiveListResponse, iReviewStatusEnumResponse, iSyncDriverArchiveInfoResponse, iUpdateDriverRegistrationInfoRequest, iUpdateDriverRegistrationInfoResponse, RDriverRiskProfileResponse, RListDriverCoreSkillsResponse, RListDriverRiskProfileCompanyConfResponse, RListDriverWorkExperienceResponse } from "./define";

/**
 * 获取所有司机登记审核信息列表
 */
export const getAllDriverRegistrationInfo = (params: iAllDriverRegistrationInfoRequest) => {
  return request.get<iAllDriverRegistrationInfoResponse>('/api/v2/driverRegister/list', { params })
};

/**
 * 获取审核状态枚举值
 */
export const getReviewStatusEnum = () => {
  return request.get<iReviewStatusEnumResponse>('/api/v2/driverRegister/reviewStat');
};

/**
 * 更新司机登记审核信息（用于审核功能）
 */
export const updateDriverRegistrationInfo = (data: iUpdateDriverRegistrationInfoRequest) => {
  return request.post<iUpdateDriverRegistrationInfoResponse>('api/v2/driverRegister/update', data);
}

/**
 * 获取司机档案列表
 */
export const getDriverArchiveList = (params: iGetDriverArchiveListRequest) => {
  return request.get<iGetDriverArchiveListResponse>('/api/v2/driver/list', { params });
};
/**
 * 司机档案上传文件
 */
export const uploadDriverArchiveFile = (data: FormData) => {
  return request.post('/api/v2/resource/upload', data);
}
/**
 * 查询司机人脸信息
 */
export const getDriverFaceInfo = (params?: iFaceInfoRequest) => {
  return request.get<iFaceResponse>('/api/v2/faceInfo/list', { params });
}

/**
 * 同步司机档案信息（完全新建）
 */

export const syncDriverArchiveInfoNew = (data: iUpdateDriverRegistrationInfoRequest) => {
  return request.post<iSyncDriverArchiveInfoResponse>('/api/v2/driverRegister/sync/archive/', data);
}
/**
 * 同步司机档案信息（更新）
 */
export const syncDriverArchiveInfoUpdate = (data: iUpdateDriverRegistrationInfoRequest, driverId: number | string) => {
  return request.post<iSyncDriverArchiveInfoResponse>(`/api/v2/driverRegister/sync/archive/${driverId}`, data);
}
/**
 * 阿里云人脸检测接口
 */
export const aliyunFaceDetect = (data: FormData) => {
  return request.post<iFaceInfoResponse>('/api/v2/faceInfo/detect', data);
}

/**
 * 同步人脸信息（完全新建）
 */
export const syncFaceInfoNew = (data: FaceInfo) => {
  return request.post<iBindFaceNewResponse>('/api/v2/driverRegister/sync/face', data);
}

/**
 * 同步人脸信息（更新）
 */
export const syncFaceInfoUpdate = (faceInfoId:string, data: FaceInfo) => {
  return request.post<iBindFaceNewResponse>(`/api/v2/driverRegister/sync/face/${faceInfoId}`, data);
}

/**
 *更新司机档案
 */
export const updateDriverArchiveInfo = (data: iDriverRequest) => {
  return request.post<iDriverResponse>('/api/v2/driver/update', data);
}

/**
 * 根据司机ID获取司机核心技能列表
 */
export const getDriverCoreSkills = (driverId: number | string) => {
  return request.get<RListDriverCoreSkillsResponse>(`/api/v2/driverCoreSkills/list`, { params: { driverId } });
};

/**
 * 修改/新增司机核心技能信息
 */
export const upsertDriverCoreSkills = (data: DriverCoreSkills) => {
  return request.post('/api/v2/driverCoreSkills/upsert', data);
};
/**
 * 删除司机核心技能信息
 */
export const deleteDriverCoreSkills = (id: number | string) => {
  return request.delete(`/api/v2/driverCoreSkills/${id}`);
}

/**
 * 查询司机履历列表
*/
export const getDriverWorkHistory = (driverId: number | string) => {
  return request.get<RListDriverWorkExperienceResponse>(`/api/v2/driverWorkExperience/list`, { params: { driverId } });
}
/**
 * 修改/新增司机履历信息
 */
export const upsertDriverWorkHistory = (data: DriverWorkExperience) => {
  return request.post('/api/v2/driverWorkExperience/upsert', data);
}
/**
 * 删除司机履历信息
 */
export const deleteDriverWorkHistory = (id: number | string) => {
  return request.delete(`/api/v2/driverWorkExperience/${id}`);
}

/**
 * 获取安全评估基本信息列表
 */
export const getDriverSafetyAssessment = (driverId: number | string) => {
  return request.get<RDriverRiskProfileResponse>(`api/v2/driverRiskProfile/${driverId}`, );
}

//FIXME: 修改安全评估基本信息
export const editDriverSafetyAssessment = ( data: DriverRiskProfile) => {
  return request.post<RDriverRiskProfileResponse>(`api/v2/driverRiskProfile/upsert`, data);
}

/**
 * 获取司机风险画像车队配置信息列表
 */
export const getDriverRiskProfileCompanyConfig = (params: CompanyConfigRequest) => {
  return request.get<RListDriverRiskProfileCompanyConfResponse>(`api/v2/driverRiskProfileCompanyConf/list`, { params });
}
/**
 * 添加 司机风险画像车队配置信息
 */
export const addDriverRiskProfileCompanyConfig = (data: DriverRiskProfileCompanyConf) => {
  return request.post<BooleanResponse>(`/api/v2/driverRiskProfileCompanyConf/insert`, data);
}
/**
 * 删除 司机风险画像车队配置信息
 */
export const deleteDriverRiskProfileCompanyConfig = (id: number | string) => {
  return request.delete<BooleanResponse>(`/api/v2/driverRiskProfileCompanyConf/${id}`);
}